require('./bootstrap');

import { createApp, h } from 'vue';
import { createInertiaApp, Link } from '@inertiajs/inertia-vue3';
import { InertiaProgress } from '@inertiajs/progress';

// Plugins
import { i18nVue } from 'laravel-vue-i18n'
import Notifications from 'notiwind'
import { MotionPlugin } from '@vueuse/motion'

// Mixins
import * as base from './base';

// Misc
const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Laravel';

createInertiaApp({
    // title: (title) => `${title} - ${appName}`,
    resolve: (name) => require(`./Pages/${name}.vue`),
    setup({ el, app, props, plugin }) {
        return createApp({ render: () => h(app, props) })
            /* Plugins */
            .use(plugin)
            // .use(i18nVue, {
            //     resolve: lang => import(`../lang/${lang}.json`),
            // })
            .use(i18nVue)
            .use(Notifications)
            .use(MotionPlugin, {
                directives: {
                    'layout-in': {
                        initial: {
                            x: -10000,
                        },
                        enter: {
                            x: 0,
                            transition: {
                                // stiffness: 50,
                                // damping: 10,
                                mass: 0.1,
                                // type: 'spring',
                                // stiffness: 2,
                                // damping: 10,
                                // repeat: Infinity,
                                // repeatType: 'mirror',
                            },
                        }
                    },
                    'up-down': {
                        initial: {
                            y: 0,
                        },
                        enter: {
                            y: -10,
                            transition: {
                                type: 'spring',
                                stiffness: 2,
                                damping: 0,
                                repeat: Infinity,
                                repeatType: 'mirror',
                            },
                        }
                    },
                    'pulse': {
                        initial: {
                            r: 0,
                            opacity: 0.25,
                        },
                        enter: {
                            r: 63,
                            opacity: 0.05,
                            transition: {
                                repeat: Infinity,
                                repeatType: 'loop',
                                duration: 1500,
                                ease: 'easeOut',
                                delay: 200,
                            },
                        },
                    },
                    'pulse-opacity': {
                        initial: {
                            opacity: 1,
                            x: 0,
                        },
                        enter: {
                            opacity: 0.40,
                            x: 0,
                            transition: {
                                repeat: Infinity,
                                repeatType: 'mirror',
                                duration: 2500,
                                delay: 200,
                            },
                        },
                    },
                }
            })
            /* Mixins */
            // .mixin({
            //     methods: {
            //         // added here
            //         changeLocale: function (locale) {
            //             Ziggy.defaults = {
            //                 locale: locale,
            //             };
            //         },
            //     }
            // })
            .mixin({ methods: { route } })
            .mixin(base)
            /* Components */
            .component('inertia-link', Link)
            .mount(el);
    },
});

InertiaProgress.init({ color: '#00e091' });
